import { render } from "./CamProductionForm.vue?vue&type=template&id=81231c0a"
import script from "./CamProductionForm.vue?vue&type=script&lang=js"
export * from "./CamProductionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__